var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-section',{attrs:{"title":_vm.Info.Section.LowStockReminder.Title}},[_c('kst-output',{attrs:{"field":"LowStockEmailLastSent","data":_vm.details,"catalog":_vm.Catalog}}),_c('List',{staticClass:"mt-5",attrs:{"emailList":_vm.details.LowStockEmail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }